<button mat-stroked-button (click)="onButtonClick($event)" [disabled]="disabled">
  <strong>
    <ng-content></ng-content>
  </strong>
</button>
